<template>
    <div class="rp-messenger-footer-content">
        <div v-if="helpcenterConfiguration.helpcenterStyles && helpcenterConfiguration.helpcenterStyles.brandLogo && helpcenterConfiguration.helpcenterStyles.brandLogo != 'NA'" class="rp-messenger-footer-logo">
            <img :src="brandLogo" />
        </div>
        <div class="rp-messenger-footer-links">
            <div class="url-label">
                <a v-if="gatSocialMediaLink && gatSocialMediaLink.website" :href="gatSocialMediaLink.website" target="_blank"> 
                    <span> {{$t('homeScreen.goto') +' '+ brandName }}  </span>
                </a>
            </div>
            <div class="rp-messenger-social-media-links">
                <a v-if="gatSocialMediaLink && gatSocialMediaLink.facebook" :href="facebookUrl" target="_blank" class="footer-links"> 
                    <svg xmlns="http://www.w3.org/2000/svg" id="prefix__facebook" width="16" height="16" viewBox="0 0 16 16">
                        <path id="prefix__Path_72" d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" data-name="Path 72" style="fill:#909aa5;opacity:.99"/>
                        <path id="prefix__Path_73" d="M13.715 9.215V7.329c0-.521.422-.472.943-.472h.942V4.5h-1.885a2.829 2.829 0 0 0-2.829 2.829v1.886H9v2.358h1.886v5.187h2.829v-5.187h1.415l.943-2.358z" data-name="Path 73" transform="translate(-2.699 -.76)" style="fill:#fff"/>
                    </svg>
                </a>
                <a v-if="gatSocialMediaLink && gatSocialMediaLink.twitter" :href="gatSocialMediaLink.twitter" target="_blank" class="footer-links"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 13">
                        <path id="prefix__twitter" d="M16 49.539a6.838 6.838 0 0 1-1.89.518 3.262 3.262 0 0 0 1.443-1.813 6.555 6.555 0 0 1-2.08.794A3.28 3.28 0 0 0 7.8 51.281a3.378 3.378 0 0 0 .076.748A9.284 9.284 0 0 1 1.114 48.6a3.281 3.281 0 0 0 1.008 4.384 3.239 3.239 0 0 1-1.482-.4v.036a3.3 3.3 0 0 0 2.628 3.223 3.274 3.274 0 0 1-.86.108 2.9 2.9 0 0 1-.621-.056 3.311 3.311 0 0 0 3.065 2.285 6.591 6.591 0 0 1-4.067 1.4A6.144 6.144 0 0 1 0 59.528 9.234 9.234 0 0 0 5.032 61a9.272 9.272 0 0 0 9.336-9.334c0-.145-.005-.285-.012-.424A6.544 6.544 0 0 0 16 49.539z" transform="translate(0 -48)" style="fill:#909aa5"/>
                    </svg>
                </a>
            </div>
            <PoweredBy 
                class="rp-power-by-logo"
                :getPoweredByURL="getPoweredByURL"
            />
        </div>
    </div>
</template>

<script>
import PoweredBy from './PoweredBy'
import { START_WITH_HTTP } from '../helper/constants'
import { COMMAN_IMG_URL } from '../constants'
export default {
    props: {
        helpcenterConfiguration: Object ,
        getPoweredByURL: String,
        brandName: String,
    },
    computed: {
        gatSocialMediaLink() {
            return this.helpcenterConfiguration.helpcenterStyles && this.helpcenterConfiguration.helpcenterStyles.socialMediaLink
        },
        brandLogo() {
            return COMMAN_IMG_URL + this.helpcenterConfiguration.helpcenterStyles.brandLogo || 'NA'
        },
        facebookUrl() {
            if (this.gatSocialMediaLink && this.gatSocialMediaLink.facebook && !START_WITH_HTTP.test(this.gatSocialMediaLink.facebook)) {
                return 'https://' + this.gatSocialMediaLink.facebook
            } else 
            return this.gatSocialMediaLink.facebook
        },
    },
    components: {
        PoweredBy
    }
}
</script>

<style lang="scss" scoped>
.rp-messenger-footer-content {
    padding: 40px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .rp-power-by-logo {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .rp-messenger-footer-logo {
        margin-bottom: 14px;
        filter: grayscale(10);
        img {
            max-height: 40px;
        }
    }
    .rp-messenger-footer-links {
        .url-label {
            font-size: 14px;
            font-weight: 400;
            color: #909aa5;
            margin: 14px 0px;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: block;
            text-align: center;
            white-space: nowrap;
        }
    }
    .rp-messenger-social-media-links {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 22px;
        .footer-links {
            margin-left: 10px;
            margin-right: 10px;
        }
    }
}
</style>